export default {"src":"/_next/static/media/user-case-bg.be238bae.svg","height":645,"width":1440,"blurWidth":0,"blurHeight":0};